import { createSelector } from 'reselect'
import { getActiveRole } from 'utils/token'
import { ROLES } from 'constants/enums'

const organizations = state => state.api.organizations.listROs
const activeOrganization = state => state.auth.organization

const mapForDropdown = (orgs, activeOrg) => {
  const ros = orgs.map(item => {
    return {
      value: item.id,
      label: item.name
    }
  })

  if (getActiveRole(activeOrg) === ROLES.IF_STAFF_SUPER.u) {
    const iaf = { value: activeOrg.id, label: activeOrg.name }

    ros.push(iaf)
  }

  return ros
}

export default createSelector(organizations, activeOrganization, mapForDropdown)
